import React from 'react';
import { VioletIcon, getJsonValue } from '../DetailComponents/utils';

const jv = (item, field, def) => getJsonValue(item, field, def);

export const basuraConfig = {
  id: 'basura',
  label: 'Gestión de Residuos',
  regex: /basur|residuos|residuo|basurero/,
  autoHeatmap: true,
  icon: VioletIcon,
  jsonFields: [
    { key: 'tipo_principal', label: 'Tipo Principal' },
    { key: 'ubicacion_especial', label: 'Ubicación Especial' },
    { key: 'en_calzada', label: 'En Calzada' },
    { key: 'obstruccion_calzada', label: 'Obstrucción Calzada' },
    { key: 'monticulo_tamano', label: 'Tamaño Montículo' },
    { key: 'estimacion_bolsas_cant', label: 'Cant. Estimada Bolsas' },
    { key: 'bolsas_rotas_dispersion', label: 'Bolsas Rotas', type: 'bool' },
    { key: 'acumulacion', label: 'Acumulación', type: 'bool' },
    { key: 'animal_muerto', label: 'Animal Muerto', type: 'bool' },
    { key: 'bolsas', label: 'Bolsas', type: 'bool' },
    { key: 'escombro', label: 'Escombro', type: 'bool' },
    { key: 'neumatico', label: 'Neumático', type: 'bool' },
    { key: 'voluminoso', label: 'Voluminoso', type: 'bool' },
  ],
  renderExtraInfo: (item) => (
    <div className="text-muted x-small" style={{ fontSize: '0.6rem' }}>
      Cat: {jv(item, 'tipo_principal', 'N/A')}
    </div>
  ),
  subFilters: [
    { id: 'bolsas_rotas', label: 'Bolsas Rotas', check: (m) => jv(m, 'bolsas_rotas_dispersion') == 1 },
    { id: 'acumulacion', label: 'Acumulación', check: (m) => jv(m, 'acumulacion') == 1 },
    { id: 'animal_muerto', label: 'Animal Muerto', check: (m) => jv(m, 'animal_muerto') == 1 },
    { id: 'bolsas', label: 'Bolsas', check: (m) => jv(m, 'bolsas') == 1 },
    { id: 'escombro', label: 'Escombros', check: (m) => jv(m, 'escombro') == 1 },
    { id: 'neumatico', label: 'Neumático', check: (m) => jv(m, 'neumatico') == 1 },
    { id: 'voluminoso', label: 'Voluminoso', check: (m) => jv(m, 'voluminoso') == 1 }
  ],
  calculatePriority: (item) => {
    const enCalzada = jv(item, 'en_calzada');
    const animalMuerto = jv(item, 'animal_muerto');
    const acumulacion = jv(item, 'acumulacion');
    if (enCalzada === 'calzada' || enCalzada === 'parcial' || animalMuerto == 1) return 'ALTA';
    if (acumulacion == 1) return 'Media';
    return 'Baja';
  },
  calculateCompany: (item) => {
    const tipoPrincipal = jv(item, 'tipo_principal');
    const bolsasRotas = jv(item, 'bolsas_rotas_dispersion');
    if (tipoPrincipal === 'bolsas' && bolsasRotas !== '1') return 'SANTA ELENA';
    return 'GRUPO L';
  },
  summaryConfig: {
    showCompanyKPI: true,
    showPriorityKPI: true,
    mainChart: 'sub-categories'
  },
  hasPriority: true,
  hasCompany: true
};
